import ReportOverview from "./ReportOverview";

const CustomerDashboard = (props) => {
  const { handleProgramTab , programListAcess } = props;
  return <ReportOverview handleProgramTab={handleProgramTab} programListAcess={programListAcess}/>;
};

export default CustomerDashboard;
